<template>
	
	<BarArrowButton :flex="true" :large="true" class="linkAccounts " title="Keep Your Accounts Connected" href="/#/Accounts/All/Relink" :bgImage="require('@/assets/bg/vault.png')">
		<div class="barArrowButtonSlotContent">
			<a href="/#/Accounts/All/Relink">
			<p>To keep your account data flowing smoothly, we need you to refresh the permissions for some of your connected bank accounts. This only takes a moment.</p>
			</a>
		</div>
	</BarArrowButton>
	
</template>

<script>
import BarArrowButton from './BarArrowButton.vue';

export default {
	name: "ReLinkAccountsShoutPanel",
	props: [],
	components: {
		BarArrowButton
	},
	data() {
		return{
			something: null
		}
	},
	methods: {
		onLoad() {
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.barArrowButtonSlotContent {
	padding: 20px;
	padding-top: 12px;
	padding-bottom: 5px;
	p {
		margin-top: -5px;
		font-size: 13px;
	}
}


</style>